import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import ContentMenu from '../components/content/ContentMenu.vue';
import ContentList from '../components/content/ContentList.vue';
import ContentSchedules from '../components/content/ContentSchedules.vue';
import ContentDiscounts from '../components/content/ContentDiscounts.vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContentView',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ContentMenu),
    (_unref(route).path === '/content')
      ? (_openBlock(), _createBlock(ContentList, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(route).path === '/content/schedule')
      ? (_openBlock(), _createBlock(ContentSchedules, { key: 1 }))
      : _createCommentVNode("", true),
    (_unref(route).path === '/content/discounts')
      ? (_openBlock(), _createBlock(ContentDiscounts, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})